@if (hoveredTask) {
    <div
        class="task-popover px-4 py-3"
        data-qa="task-popover"
        [ngStyle]="{ 'top.px': popoverPosition.y, 'left.px': popoverPosition.x }"
    >
        <dl class="m-0">
            @if (hoveredTask.assignedUserIsOverridden || hoveredTask.assignedTeamIsOverridden) {
                <dt>Ult. Resp. Of:</dt>
                <dd class="ms-1" data-qa="task-ult-resp-user">
                    {{ hoveredTask.responsibleUser.firstName + ' ' + hoveredTask.responsibleUser.lastName }}</dd
                >
                <dt class="mb-2"></dt>
                <dd class="ms-1 mb-2" data-qa="task-ult-resp-team"> {{ hoveredTask.responsibleTeam.name }}</dd>
            }
            <dt>Assigned To:</dt>
            <dd class="ms-1" data-qa="task-assigned-user">
                {{ hoveredTask.assignedUser.firstName + ' ' + hoveredTask.assignedUser.lastName }}</dd
            >
            <dt class="mb-2">&nbsp;</dt>
            <dd class="ms-1 mb-2" data-qa="task-assigned-team">{{ hoveredTask.assignedTeam.name }}</dd>
            @if (hoveredTask.completedDateTime) {
                <dt>Completed By:</dt>
                <dd class="ms-1" data-qa="task-completed-user">{{
                    hoveredTask.completedByUser
                        ? hoveredTask.completedByUser.firstName + ' ' + hoveredTask.completedByUser.lastName
                        : ''
                }}</dd>
                <dt class="mb-2">&nbsp;</dt>
                <dd class="ms-1 mb-2" data-qa="task-completed-date"
                    >{{ hoveredTask.completedDateTime | weissmanDateTimeFormat: false : 'Central' }} CT</dd
                >
            }
        </dl>
    </div>
}
@if (contextMenu && contextMenu.length > 0) {
    <div
        class="task-popover context-menu px-3 py-2"
        [ngStyle]="{ 'top.px': popoverPosition.y, 'left.px': popoverPosition.x }"
    >
        <ul class="m-0 p-0" data-qa="task-context-menu">
            @for (item of contextMenu; track item.label; let i = $index) {
                @if (item.action) {
                    <li
                        class="action-item px-2 py-1"
                        [attr.data-qa]="'task-context-menu-item-' + i"
                        (click)="item.action()"
                    >
                        {{ item.label }}
                    </li>
                }
                @if (item.children && item.children.length > 0) {
                    <li [attr.data-qa]="'task-context-menu-item-' + i">
                        <span class="px-2 py-1" [attr.data-qa]="'task-context-submenu-label-' + i">
                            <b>{{ item.label }} <i class="fa fa-chevron-down fa-rotate-270 ms-3"></i></b>
                        </span>
                        <div class="context-submenu">
                            <ul class="m-0 p-0">
                                @for (childItem of item.children; track childItem.label; let j = $index) {
                                    <li
                                        class="action-item ps-3 py-1 pe-2"
                                        [attr.data-qa]="'task-context-submenu-' + i + '-item-' + j"
                                        (click)="childItem.action()"
                                    >
                                        {{ childItem.label }}
                                    </li>
                                }
                            </ul>
                        </div>
                    </li>
                }
            }
        </ul>
    </div>
}
